import React from 'react';
import PropTypes from 'prop-types';

import { AdminHeader, AdminPage, AdminTitle, AdminViewIntegrations } from 'components/admin/lib/admin_layout';
import connect from 'components/lib/connect';
import IntegrationsNav from 'components/admin/integrations/integrations_nav';
import FullPageSpinner from 'components/common/full_page_spinner';
import LookupApiConfigForm from './lookup_api_config_form';

export default connect(mapStateToProps)(LookupApiConfigPage);

function mapStateToProps({ getProvider }) {
  let lookupApiConfigProvider = getProvider('lookupApiConfig');
  return {
    isLoading: lookupApiConfigProvider.isLoading(),
  };
}

LookupApiConfigPage.propTypes = {
  isLoading: PropTypes.bool,
  isPending: PropTypes.bool,
};

export function LookupApiConfigPage({ isLoading, isPending }) {
  let bodyContent;
  if (isLoading) {
    bodyContent = <FullPageSpinner />;
  } else {
    bodyContent = <LookupApiConfigForm />;
  }

  return (
    <AdminPage>
      <IntegrationsNav>
        <AdminViewIntegrations className="lookupApiConfig">
          <AdminHeader className="lookupApiConfig-header">
            <AdminTitle>Customer Lookup</AdminTitle>
          </AdminHeader>
          <div className="lookupApiConfig-body">{bodyContent}</div>
        </AdminViewIntegrations>
      </IntegrationsNav>
    </AdminPage>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/lookup_api_config/lookup_api_config_page.jsx